module.exports = __webpack_public_path__ + "img/loading_bottom.75ca745d.jpg";